<template>
  <div class="plan-forcast-update clearfix">
    <compWrapper title="Base Infomation" theme="primary">
      <compFormQuery 
                     class="margin-15"
                     ref="formbase"
                     placeholder="--"
                     :formdata="getBase"
                     v-model="formData"
                     :labelWidth="130"></compFormQuery>
    </compWrapper>
    <!-- <compWrapper title="操作历史" theme="gray">
      <compLog :data="logList"></compLog>
    </compWrapper> -->
    <Spin v-if="loading" fix></Spin>
  </div>
</template>

<script>
import {
  HttpGetPoAmazonDetail
} from "@/service/purchase/purchase";
import { mapState, mapGetters } from "vuex";
export default {
  props: ["activeid"],
  data () {
    return {
      id: this.activeid ? this.activeid : this.$route.query.id,
      loading: false,
      logLoading: false,
      formData: {},
      logList: [],
    };
  },
  mounted () {
    this.getDetail();
  },
  computed: {
    ...mapGetters("diction", ["getNewDifferentAllProductList"]),
    getBase () {
      return [
        {
            label: "ERPSKU",
            key: "erpSku",
        },
        {
            label: 'Seller SKU',
            key:'sellerSku',
        },
        {
            label: 'Account',
            key:'accountFlag',
            
        },
        {
            label: 'ASIN',
            key:'asin',
        },
        
        {
            label: 'Title',
            key:'productTitle',
        },
        {
            label: 'Avaliable Inventory',
            key:'availableInventory',
        },
        {
            label: 'Open Purchase Order Quantity',
            key:'openPurchaseOrderQuantity'
        },
        {
            label: 'Inventory Date',
            key:'inventoryTime'
        },
        {
            label: 'Vverall Vendor Lead Time',
            key:'overall_vendor_lead_time'
        },
        {
            label: 'Replenishment Category',
            key:'replenishment_category'
        },
        {
            label: 'Create Time',
            key: 'createdAt',
        },
        {
            label: 'Update Time',
            key: 'updatedAt',
        },
        {
            label: 'week1',
            key: 'week1',
        },
        {
            label: 'week2',
            key: 'week2',
        },
        {
            label: 'week3',
            key: 'week3',
        },
        {
            label: 'week4',
            key: 'week4',
        },
        {
            label: 'week5',
            key: 'week5',
        },
        {
            label: 'week6',
            key: 'week6',
        },
        {
            label: 'week7',
            key: 'week7',
        },
        {
            label: 'week8',
            key: 'week8',
        },
        {
            label: 'week9',
            key: 'week9',
        },
        {
            label: 'week10',
            key: 'week10',
        },
        {
            label: 'week11',
            key: 'week11',
        },
        {
            label: 'week12',
            key: 'week12',
        },
        {
            label: 'week13',
            key: 'week13',
        },
        {
            label: 'weekMean1',
            key: 'weekMean1',
        },
        {
            label: 'weekMean2',
            key: 'weekMean2',
        },
        {
            label: 'weekMean3',
            key: 'weekMean3',
        },
        {
            label: 'weekMean4',
            key: 'weekMean4',
        },
        {
            label: 'weekMean5',
            key: 'weekMean5',
        },
        {
            label: 'weekMean6',
            key: 'weekMean6',
        },
        {
            label: 'weekMean7',
            key: 'weekMean7',
        },
        {
            label: 'weekMean8',
            key: 'weekMean8',
        },
        {
            label: 'weekMean9',
            key: 'weekMean9',
        },
        {
            label: 'weekMean10',
            key: 'weekMean10',
        },
        {
            label: 'weekMean11',
            key: 'weekMean11',
        },
        {
            label: 'weekMean12',
            key: 'weekMean12',
        },
        {
            label: 'weekMean13',
            key: 'weekMean13',
        },
        {
            label: 'weekMean14',
            key: 'weekMean14',
        },
        {
            label: 'weekMean15',
            key: 'weekMean15',
        },
        {
            label: 'weekMean16',
            key: 'weekMean16',
        },
        {
            label: 'weekMean17',
            key: 'weekMean17',
        },
        {
            label: 'weekMean18',
            key: 'weekMean18',
        },
        {
            label: 'weekMean19',
            key: 'weekMean19',
        },
        {
            label: 'weekMean20',
            key: 'weekMean20',
        },
        {
            label: 'weekMean21',
            key: 'weekMean21',
        },
        {
            label: 'weekMean22',
            key: 'weekMean22',
        },
        {
            label: 'weekMean23',
            key: 'weekMean23',
        },
        {
            label: 'weekMean24',
            key: 'weekMean24',
        },
        {
            label: 'weekMean25',
            key: 'weekMean25',
        },
        {
            label: 'weekMean26',
            key: 'weekMean26',
        },
        {
            label: 'weekP701',
            key: 'weekP701',
        },
        {
            label: 'weekP702',
            key: 'weekP702',
        },
        {
            label: 'weekP703',
            key: 'weekP703',
        },
        {
            label: 'weekP704',
            key: 'weekP704',
        },
        {
            label: 'weekP705',
            key: 'weekP705',
        },
        {
            label: 'weekP706',
            key: 'weekP706',
        },
        {
            label: 'weekP707',
            key: 'weekP707',
        },
        {
            label: 'weekP708',
            key: 'weekP708',
        },
        {
            label: 'weekP709',
            key: 'weekP709',
        },
        {
            label: 'weekP801',
            key: 'weekP801',
        },
        {
            label: 'weekP802',
            key: 'weekP802',
        },
        {
            label: 'weekP803',
            key: 'weekP803',
        },
        {
            label: 'weekP804',
            key: 'weekP804',
        },
        {
            label: 'weekP805',
            key: 'weekP805',
        },
        {
            label: 'weekP806',
            key: 'weekP806',
        },
        {
            label: 'weekP807',
            key: 'weekP807',
        },
        {
            label: 'weekP808',
            key: 'weekP808',
        },
        {
            label: 'weekP809',
            key: 'weekP809',
        },
        {
            label: 'weekP901',
            key: 'weekP901',
        },
        {
            label: 'weekP902',
            key: 'weekP902',
        },
        {
            label: 'weekP903',
            key: 'weekP903',
        },
        {
            label: 'weekP904',
            key: 'weekP904',
        },
        {
            label: 'weekP905',
            key: 'weekP905',
        },
        {
            label: 'weekP906',
            key: 'weekP906',
        },
        {
            label: 'weekP907',
            key: 'weekP907',
        },
        {
            label: 'weekP908',
            key: 'weekP908',
        },
        {
            label: 'weekP909',
            key: 'weekP909',
        },
        {
            label: 'weekP7010',
            key: 'weekP7010',
        },
        {
            label: 'weekP7011',
            key: 'weekP7011',
        },
        {
            label: 'weekP7012',
            key: 'weekP7012',
        },
        {
            label: 'weekP7013',
            key: 'weekP7013',
        },
        {
            label: 'weekP7014',
            key: 'weekP7014',
        },
        {
            label: 'weekP7015',
            key: 'weekP7015',
        },
        {
            label: 'weekP7016',
            key: 'weekP7016',
        },
        {
            label: 'weekP7017',
            key: 'weekP7017',
        },
        {
            label: 'weekP7018',
            key: 'weekP7018',
        },
        {
            label: 'weekP7019',
            key: 'weekP7019',
        },
        {
            label: 'weekP7020',
            key: 'weekP7020',
        },
        {
            label: 'weekP7021',
            key: 'weekP7021',
        },
        {
            label: 'weekP7022',
            key: 'weekP7022',
        },
        {
            label: 'weekP7023',
            key: 'weekP7023',
        },
        {
            label: 'weekP7024',
            key: 'weekP7024',
        },
        {
            label: 'weekP7025',
            key: 'weekP7025',
        },
        {
            label: 'weekP7026',
            key: 'weekP7026',
        },

        {
            label: 'weekP8010',
            key: 'weekP8010',
        },
        {
            label: 'weekP8011',
            key: 'weekP8011',
        },
        {
            label: 'weekP8012',
            key: 'weekP8012',
        },
        {
            label: 'weekP8013',
            key: 'weekP8013',
        },
        {
            label: 'weekP8014',
            key: 'weekP8014',
        },
        {
            label: 'weekP8015',
            key: 'weekP8015',
        },
        {
            label: 'weekP8016',
            key: 'weekP8016',
        },
        {
            label: 'weekP8017',
            key: 'weekP8017',
        },
        {
            label: 'weekP8018',
            key: 'weekP8018',
        },
        {
            label: 'weekP8019',
            key: 'weekP8019',
        },
        {
            label: 'weekP8020',
            key: 'weekP8020',
        },
        {
            label: 'weekP8021',
            key: 'weekP8021',
        },
        {
            label: 'weekP8022',
            key: 'weekP8022',
        },
        {
            label: 'weekP8023',
            key: 'weekP8023',
        },
        {
            label: 'weekP8024',
            key: 'weekP8024',
        },
        {
            label: 'weekP8025',
            key: 'weekP8025',
        },
        {
            label: 'weekP8026',
            key: 'weekP8026',
        },

        {
            label: 'weekP9010',
            key: 'weekP9010',
        },
        {
            label: 'weekP9011',
            key: 'weekP9011',
        },
        {
            label: 'weekP9012',
            key: 'weekP9012',
        },
        {
            label: 'weekP9013',
            key: 'weekP9013',
        },
        {
            label: 'weekP9014',
            key: 'weekP9014',
        },
        {
            label: 'weekP9015',
            key: 'weekP9015',
        },
        {
            label: 'weekP9016',
            key: 'weekP9016',
        },
        {
            label: 'weekP9017',
            key: 'weekP9017',
        },
        {
            label: 'weekP9018',
            key: 'weekP9018',
        },
        {
            label: 'weekP9019',
            key: 'weekP9019',
        },
        {
            label: 'weekP9020',
            key: 'weekP9020',
        },
        {
            label: 'weekP9021',
            key: 'weekP9021',
        },
        {
            label: 'weekP9022',
            key: 'weekP9022',
        },
        {
            label: 'weekP9023',
            key: 'weekP9023',
        },
        {
            label: 'weekP9024',
            key: 'weekP9024',
        },
        {
            label: 'weekP9025',
            key: 'weekP9025',
        },
        {
            label: 'weekP9026',
            key: 'weekP9026',
        },
        {
            label: 'weeksOnHand',
            key: 'weeksOnHand',
        },
      ];
    },
  },
  methods: {
    async getDetail () {
      this.loading = true;
      await HttpGetPoAmazonDetail({
        id: this.id,
      })
        .then(
          (res) => {
            this.formData = res.data;
          },
          (err) => {
            this.$VMessage.error(err.message);
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style>
</style>
